export const REDUCER_KEY = 'committedOrders';
